import { LIGHTBULB_URL } from "@/constants/tutorial";

interface LightbulbBtnProps {
  onClick: () => void;
}

export default function LightbulbBtn({ onClick }: LightbulbBtnProps) {
  return (
    <button
      type="button"
      aria-label="Take a tour"
      title="Take a tour"
      onClick={onClick}
      className="absolute top-15 left-4 size-15 z-5 p-1 flex items-center justify-center rounded-full bg-white border border-smoke cursor-pointer transition-all hover:border-dark-dust hover:shadow-md active:scale-[0.96]"
      style={{ boxShadow: "0 2px 6px rgba(0,0,0,0.06)" }}
    >
      <img
        src={LIGHTBULB_URL}
        alt=""
        aria-hidden="true"
        loading="lazy"
        style={{ width: "100%", height: "100%", objectFit: "contain", pointerEvents: "none" }}
      />
    </button>
  );
}
